import ModelFactoryChoice, {IModelFactoryChoices} from "../ModelFactoryChoice";
import {IAnyObject} from "../../../common/SimpleInterface";
import {isNumeric, isString} from "../../../common/SiteHelper";

class DataChoice extends ModelFactoryChoice
{
    slug:string;
    receivedObject:IAnyObject;

    constructor(object:IAnyObject)
    {
        const id = isString(object.id) ? object.id : (isNumeric(object.id) ? object.id + "" : "");
        super(id);
        this.slug = object.slug ?? id;
        this.name = object.name ?? this.slug;
        this.receivedObject = object;
    }

}

export interface IDataChoices extends IModelFactoryChoices
{
    [key: string]: DataChoice;
}

export default DataChoice;